'use client';
import { Global } from '@emotion/react';
import React from 'react';
export const Fonts = ()=>/*#__PURE__*/ React.createElement(Global, {
        styles: `
      @font-face {
        font-family: Poppins;
        font-display: swap;
        font-style: normal;
        font-weight: 400;
        src: url('https://cdn.ironhack.com/fonts/poppins/Poppins-Regular.woff2')
          format('woff2');
      }
      @font-face {
        font-family: Poppins;
        font-display: swap;
        font-style: normal;
        font-weight: 600;
        src: url('https://cdn.ironhack.com/fonts/poppins/Poppins-SemiBold.woff2')
          format('woff2');
      }
      @font-face {
        font-family: Poppins;
        font-display: swap;
        font-style: italic;
        font-weight: 800;
        src: url('https://cdn.ironhack.com/fonts/poppins/Poppins-ExtraBoldItalic.woff2')
          format('woff2');
      }
    `
    });

//# sourceMappingURL=fonts.js.map